/**
 * View 2 preset: "Year to date" = Jan 1 of the current calendar year through today (local).
 * Matches marketing Analytics Tab / PM spec (e.g. week 17 → Jan 1 … current day).
 */
export function getView2YtdDateRange(referenceDate = new Date()) {
  const end = new Date(referenceDate);
  end.setHours(0, 0, 0, 0);
  const start = new Date(end.getFullYear(), 0, 1);

  const toYyyyMmDd = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };

  return {
    dateStart: toYyyyMmDd(start),
    dateEnd: toYyyyMmDd(end),
  };
}
